import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const usePageTitle = (pageNameKey: string) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('app.pageTitle', { name: t(pageNameKey) });
  }, [t]);
};

export default usePageTitle;
